import axios from "axios";
import {startOfDay} from "vue-datetime/src/util";
import {orderBy} from "element-ui/packages/table/src/util";
// initial state
const state = {};

// getters
const getters = {};

// actions
const actions = {
	GetReportList({ commit }, list) {
		console.log("list", list)
		return new Promise((resolve, reject) => {
			console.log('list', list)
			axios({
				// v1/log/report?start_time=1630482598&end_time=1631346598&fields=sent%2Cdelivered%2Ctx_cost&group=country%2Cdnis_prefix&sort=sms_time&order=desc&step=day
				// v1/log/report?start_time=1631476800&end_time=1631563199&fields=sent,delivered,tx_cost&group=country,dnis_prefix&sort=sms_time&order=desc&step=day
				url: `log/report?start_time=${list.start_time}&end_time=${list.end_time}&fields=sent%2Cdelivered%2Ctx_cost&group=country%2Cdnis_prefix&sort=${list.order_by}&order=${list.order_dir}&step=${list.step || 'day'}&dnis=${list.dnis || ''}`,
				method: 'GET',
			}).then(res => {
				console.log('res1', res)
				resolve(res.data);
			})
		});
	},

	GetSystemUsageReportList({ commit }, list) {
		console.log("list", list)
		return new Promise((resolve, reject) => {
			console.log('list', list)
			axios({
				url: `log/report?start_time=${list.start_time}&end_time=${list.end_time}&fields=sent%2Cdelivered%2Ctx_cost${list.group ? '&group='+list.group : ''}&step=${list.step || 'day'}&dnis_prefix=${list.dnis_prefix || ''}&ani=${list.ani || ''}&vendor_id=${list.vendor_uuid || ''}&company_name=${list.company_name || ''}`,
				method: 'GET',
			}).then(res => {
				console.log('res1', res)
				resolve(res.data);
			})
		});
	},

	GetDestinationReportList({ commit }, list) {
		console.log("list", list)
		return new Promise((resolve, reject) => {
			console.log('list', list)
			axios({
				url: `log/report?start_time=${list.start_time}&end_time=${list.end_time}&fields=sent%2Cdelivered%2Ctx_cost&group=country&sort=${list.order_by}&order=${list.order_dir}&step=${list.step || 'day'}&dnis=${list.dnis || ''}`,
				method: 'GET',
			}).then(res => {
				resolve(res.data);
			})
		});
	},

	GetUsageReportList({ commit }, list) {
		return new Promise((resolve, reject) => {
			axios({
				url: `log/report?start_time=${list.start_time}&end_time=${list.end_time}&fields=sent%2Cdelivered%2Ctx_cost&step=${list.step || 'day'}&dnis_prefix=${list.dnis_prefix || ''}&ani=${list.ani || ''}`,
				method: 'GET',
			}).then(res => {
				resolve(res.data);
			})
		});
	},

	GetNumbersCompanyReportList({ commit }, list) {
		return new Promise((resolve, reject) => {
			console.log('list', list)
			axios({
				url: `log/report?start_time=${list.start_time}&end_time=${list.end_time}&fields=sent%2Cdelivered%2Ctx_cost${list.group ? '&group='+list.group : ''}&sort=${list.order_by}&order=${list.order_dir}&step=${list.step || 'day'}`,
				params: {
					dnis: list.dnis || null,
					country: list.country || null,
				},
				method: 'GET'
			}).then(res => {
				console.log('res1', res)


				// log/report?start_time=1630670880&end_time=1631908799&fields=sent%2Cdelivered%2Ctx_cost&group=country%2Cdnis_prefix&sort=sms_time&order=desc&step=day
				// log/report?start_time=1630671060&end_time=1631908799&fields=sent%2Cdelivered%2Ctx_cost&group=country%2Cdnis_prefix&sort=sms_time&order=desc&step=day&dnis_prefix=null&country=
				resolve(res.data);
			})
		});
	},

	GetNumbersReportList({ commit }, list) {
		return new Promise((resolve, reject) => {
			console.log('list', list)
			axios({
				url: `log/report?start_time=${list.start_time}&end_time=${list.end_time}&fields=sent%2Cdelivered%2Ctx_cost&group=country%2Cdnis_prefix&sort=${list.order_by}&order=${list.order_dir}&step=${list.step || 'day'}`,
				params: {
					dnis_prefix: list.dnis_prefix || null,
					country: list.country || null,
					order_dir: list.order_dir,
					order_by: list.order_by,
				},
				method: 'GET'
			}).then(res => {
				console.log('res1', res)


				// log/report?start_time=1630670880&end_time=1631908799&fields=sent%2Cdelivered%2Ctx_cost&group=country%2Cdnis_prefix&sort=sms_time&order=desc&step=day
				// log/report?start_time=1630671060&end_time=1631908799&fields=sent%2Cdelivered%2Ctx_cost&group=country%2Cdnis_prefix&sort=sms_time&order=desc&step=day&dnis_prefix=null&country=
				resolve(res.data);
			})
		});
	},
};

// mutations
const mutations = {};

export default {
	namespaced: false,
	state,
	getters,
	actions,
	mutations
};
